"use client";

import { TabBar } from "@/components/tab-bar";
import { Content } from "@/services/content/types";
import { useState } from "react";
import ItemFeed from "./item-feed";

type Tab = "artiklar" | "kommentarer" | "analyser";

type Props = {
  companyName?: string;
  articles: Content.Article[];
  comments: Content.Article[];
  analyses: Content.Article[];
  hasComments: boolean;
  hasAnalyses: boolean;
  hasMoreArticles?: boolean;
  hasMoreComments?: boolean;
  hasMoreAnalyses?: boolean;
  nextPageArticles?: number;
  nextPageComments?: number;
  nextPageAnalyses?: number;
  loadMoreArticles: (page: number) => Promise<any>;
  loadMoreComments: (page: number) => Promise<any>;
  loadMoreAnalyses: (page: number) => Promise<any>;
};

const TAB_LABELS: Record<Tab, string> = {
  artiklar: "Artiklar",
  kommentarer: "Kommentarer",
  analyser: "Analyser",
};

const InstrumentNewsTabs = ({
  companyName,
  articles,
  comments,
  analyses,
  hasComments,
  hasAnalyses,
  hasMoreArticles,
  hasMoreComments,
  hasMoreAnalyses,
  nextPageArticles,
  nextPageComments,
  nextPageAnalyses,
  loadMoreArticles,
  loadMoreComments,
  loadMoreAnalyses,
}: Props) => {
  const [activeTab, setActiveTab] = useState<Tab>("artiklar");

  const visibleTabs: Tab[] = ["artiklar"];
  if (hasComments) visibleTabs.push("kommentarer");
  if (hasAnalyses) visibleTabs.push("analyser");

  const activeItems =
    activeTab === "kommentarer" ? comments
    : activeTab === "analyser" ? analyses
    : articles;

  const activeHasMore =
    activeTab === "kommentarer" ? hasMoreComments
    : activeTab === "analyser" ? hasMoreAnalyses
    : hasMoreArticles;

  const activeNextPage =
    activeTab === "kommentarer" ? nextPageComments
    : activeTab === "analyser" ? nextPageAnalyses
    : nextPageArticles;

  const activeLoadMore =
    activeTab === "kommentarer" ? loadMoreComments
    : activeTab === "analyser" ? loadMoreAnalyses
    : loadMoreArticles;

  if (articles.length === 0 && !hasComments && !hasAnalyses) return null;

  return (
    <div className="container mb-16 border-b border-sand-700">
      <h2 className="heading-plain font-bold text-xl mb-2">
        {companyName ? `Senaste artiklarna om ${companyName}` : "Senaste nytt"}
      </h2>

      {visibleTabs.length > 1 && (
        <TabBar
          tabs={visibleTabs.map((t) => ({ label: TAB_LABELS[t], value: t }))}
          active={activeTab}
          onChange={setActiveTab}
        />
      )}

      <ItemFeed
        key={activeTab}
        items={activeItems}
        hasMore={activeHasMore}
        initialPage={activeNextPage ?? 1}
        loadMore={activeLoadMore}
      />
    </div>
  );
};

export default InstrumentNewsTabs;
